import * as React from "react";
import { observer } from "mobx-react-lite";
import { DomainCreateNG } from "../create_ng/create_ng";
import { Domain } from "../../../schema/types/domain/entity";
import { useDetailContext } from "../../../components/detail/detailContext";
import { domainToInput } from "../create_ng/utils/utils";

interface Props {
  domain: Domain;
}
const DomainNGEditRouteRaw: React.FC<Props> = ({ domain }) => {
  const { fetchItem } = useDetailContext();

  const domainForm = React.useMemo(() => {
    return domainToInput(domain);
  }, []);

  return (
    <DomainCreateNG
      domain={domain}
      initialValues={{
        ...domainForm,
        isEdit: true,
        lastPath: window.location.pathname.replace(`-edit`, ``),
      }}
      fetchItem={fetchItem}
    />
  );
};

export const DomainNGEditRoute = observer(DomainNGEditRouteRaw);
